import P5Wrapper from 'react-p5-wrapper'; // https://www.npmjs.com/package/react-p5-wrapper
import style from './style';

let p5;
const uGridInterval = 5;
const uOffsetX = 10;
const fixtureRadius = 4;
const clickRadius = 20;
const figureClickRadius = 20;

let scale = 5; // canvas units / user unit
const MAX_SCALE = 12;
const MIN_SCALE = 3;
let height = 500;
let width = 200;

let beams = [];
let dispatch = null;
const NONE_SELECTED = -1;
let selectedBeamIndex = NONE_SELECTED;
let isFigureSelected = false;
let clickOffsetX = 0;
let clickOffsetY = 0;
let draggingObject = false;
let clickedLight = false;

// Convert between user and canvas space:
// scale, offset, invert y axis relative to deck
function toCanvasScale(v) {
	return v * scale;
}

function toCanvasX(ux) {
	return toCanvasScale(ux + uOffsetX);
}

function toCanvasY(uy) {
	return height - toCanvasScale(uy);
}

function toCanvas(ux, uy) {
	return {
		x: toCanvasX(ux),
		y: toCanvasY(uy)
	};
}

function toUserScale(v) {
	return v / scale;
}

function toUserX(x) {
	return toUserScale(x) - uOffsetX;
}

function toUserY(y) {
	return toUserScale(height - y);
}

function drawGrid() {
	p5.push();
	p5.stroke(255, 255, 255, 64);
	p5.strokeWeight(1);
	const deck = toCanvasY(0);
	let x = 0;
	// vertical lines right of x=0
	for (let ux = 0; x <= width; ux += uGridInterval) {
		x = toCanvasX(ux);
		p5.line(x, deck, x, 0);
	}
	// vertical lines left of x=0
	for (let ux = -uGridInterval; x > 0; ux -= uGridInterval) {
		x = toCanvasX(ux);
		p5.line(x, deck, x, 0);
	}
	// horizontal lines above
	for (let uy = 0; uy <= height; uy += uGridInterval) {
		const y = toCanvasY(uy);
		p5.line(0, y, width, y);
	}
	p5.strokeWeight(2);
	p5.line(0, deck, width, deck);
	p5.pop();
}

function drawFigure(x, yFeet) {
	p5.push();
	// p5.ellipseMode(p5.CENTER);
	p5.fill(255);
	p5.stroke(255);
	// TODO: do metric conversion
	p5.ellipse(toCanvasX(x), toCanvasY(yFeet + 2.2), toCanvasScale(1), toCanvasScale(5));
	p5.circle(toCanvasX(x), toCanvasY(yFeet + 5), toCanvasScale(1));
	p5.pop();
}

function drawBeam(beam, selected) {
	const { x, y } = toCanvas(beam.xSource, beam.ySource);
	const { x: xf, y: yface } = toCanvas(beam.xFigure, beam.yFace);
	const yFeet = toCanvasY(beam.yFeet);
	p5.push();

	// beam line
	p5.stroke(200);
	p5.line(x, y, xf, yface);

	// beam fill
	if (beam.on) {
		p5.fill(255, 64);
		let targetAngle;
		if (beam.xSource === beam.xFigure) {
			targetAngle = beam.ySource > 5 ? 90 : -90;
		}
		else {
			targetAngle = p5.atan((beam.ySource - beam.yFace) / p5.abs(beam.xSource - beam.xFigure));
			if (beam.xSource > beam.xFigure) targetAngle = 180 - targetAngle;
		}
		const halfBeamAngle = beam.beamAngle / 2;
		const topAngle = targetAngle + halfBeamAngle;
		const bottomAngle = targetAngle - halfBeamAngle;
		p5.noStroke();
		p5.arc(x, y, 10000, 10000, bottomAngle, topAngle);
	}

	// ellipse
	// p5.stroke(200, 200, 0);
	// p5.noFill();
	// p5.ellipse( xf, yf, 20, 30);

	// dimensions
	if (selected) {
		p5.stroke(255, 255, 0);
		p5.strokeWeight(2);
		p5.line(x, y, x, yFeet);
		p5.line(x, yFeet, xf, yFeet);
		p5.strokeWeight(0);
		p5.textSize(16);
		p5.fill(255, 255, 0);

		// height
		p5.push();
		p5.translate(x, yFeet);
		p5.rotate(-90);
		p5.text(beam.ySource - beam.yFeet, 40, -4);
		p5.pop();

		// distance
		const xText = x > xf ? x - 28 : x + 8;
		p5.text(Math.abs(beam.xSource - beam.xFigure), xText, yFeet - 4);

		// throw
		p5.push();
		p5.translate((x + xf) / 2, ( y + yFeet) / 2 - 20);
		p5.rotate(-beam.elevationAngle);
		p5.text(beam.throw, 0, 0);
		p5.pop();
		
		// fc
		p5.fill(220);
		p5.text(beam.illumination, xf + 8, yface + 4);
	}

	// source
	p5.ellipseMode(p5.CENTER);
	p5.fill(255);
	p5.strokeWeight(1);
	p5.circle(x, y, fixtureRadius);
	if (selected) {
		p5.noFill();
		p5.stroke(255);
		p5.circle(x, y, fixtureRadius + 8);
	}
	p5.pop();

	// figure
	drawFigure(beam.xFigure, beam.yFeet);
}

function drawBeams(beams) {
	beams.forEach((f, index) => {
		drawBeam(f, index === selectedBeamIndex);
	});
}

function indexOfMouseBeam(mouseX, mouseY, distFunc) {
	return beams.findIndex((beam, index) => {
		// Check source click
		let x = toCanvasX(beam.xSource);
		let y = toCanvasY(beam.ySource);
		let d = p5.dist(mouseX, mouseY, x, y);
		if (d < clickRadius) {
			selectedBeamIndex = index;
			clickOffsetX = x - mouseX;
			clickOffsetY = y - mouseY;
			isFigureSelected = false;
			draggingObject = true;
			return true;
		}

		// Check figure click
		x = toCanvasX(beam.xFigure);
		y = toCanvasY(beam.yFace);
		d = distFunc(mouseX, mouseY, x, y);
		if (d < figureClickRadius) {
			selectedBeamIndex = index;
			clickOffsetX = x - mouseX;
			clickOffsetY = y - mouseY;
			isFigureSelected = true;
			draggingObject = true;
			return true;
		}
	});
}

function sketch(p) {
	p.setup = () => {
		p5 = p;
		width = p5.windowWidth;
		p5.createCanvas(width, height);
		p5.angleMode(p5.DEGREES);
	};

	p.myCustomRedrawAccordingToNewPropsHandler = function (props) {
		({ beams, dispatch, selectedBeamIndex } = props);
	};

	p.draw = () => {
		p.background(34, 102, 255);
		drawGrid();
		drawBeams(beams);
	};

	p.windowResized = () => {
		width = p5.windowWidth;
		p5.resizeCanvas(width, height);
	};

	p.mousePressed = (event) => {
		if (event.gridIgnoreClick) return;
		const index = indexOfMouseBeam(p5.mouseX, p5.mouseY, p5.dist);
		dispatch({ type: 'SELECT_BEAM', index });
		return index === NONE_SELECTED;
	};

	p.mouseDragged = () => {
		if (selectedBeamIndex !== NONE_SELECTED && draggingObject) {
			if (isFigureSelected) {
				dispatch({ type: 'VALUE_CHANGE', property: { xFigure: toUserX(p5.mouseX + clickOffsetX) } });
			}
			else {
				dispatch({ type: 'VALUE_CHANGE', property: { xSource: toUserX(p5.mouseX + clickOffsetX) } });
				dispatch({ type: 'VALUE_CHANGE', property: { ySource: toUserY(p5.mouseY + clickOffsetY) } });
			}
			return false;
		}
	};

	p.mouseReleased = () => {
		draggingObject = false;
	};

	p.doubleClicked = () => {
		if (clickedLight) {
			dispatch({ type: 'TOGGLE' });
			return false; // prevent default
		}
	};
}

function ignoreEvent(event) {
	event.gridIgnoreClick = true;
}

function plusScale(event) {
	scale = Math.min(scale + 1, MAX_SCALE);
}

function minusScale(event) {
	scale = Math.max(scale - 1, MIN_SCALE);
	event.gridIgnoreClick = true;
}

// @ts-ignore
const Graphic = ({ beams, dispatch, selectedBeamIndex }) => (
	<div class={style.graphicPage}>
		<div style={{ position: 'absolute', right: '16px' }}>
			<button onMouseDown={ignoreEvent} onClick={plusScale}>+</button><button onMouseDown={ignoreEvent} onClick={minusScale}>&ndash;</button>
		</div>
		<P5Wrapper sketch={sketch} beams={beams} dispatch={dispatch} selectedBeamIndex={selectedBeamIndex} />
	</div>
);

export default Graphic;



// WEBPACK FOOTER //
// ./components/graphic/index.js